var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgSmartRecommendation = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5142 12L19.0926 16.0784L23.171 17.6569L18.8426 19.2353L17.5142 23.3137L15.9357 19.2353L11.8573 17.6569L15.9357 16.0784L17.5142 12Z",
  fill: "#FFB81C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.48529 0L10.8529 6.11764L16.9706 8.48528L10.4779 10.8529L8.48529 16.9706L6.11765 10.8529L9.29832e-06 8.48528L6.11765 6.11764L8.48529 0Z",
  fill: "#FFB81C"
})));
export default SvgSmartRecommendation;